import React from 'react';

import FormAcesso from './FormAcesso';
import FormTreino from './FormTreino';
import FormProblemas from './FormProblemas';
import STRINGS from './../../data/language/language';
import './cadastro.css';
import LOGO from '../../img/foco90.svg';

import {CADASTRO_DADOS} from '../../config/Config';
const FORMATIVO = 0;
let arrayForms;

export default class Cadastro extends React.Component{
  constructor(props){
    super(props);

    this.state = {
      strings:STRINGS[window.LANGUAGE],
      formAtivo: FORMATIVO,
      ...CADASTRO_DADOS
    }

    this.handlerStep = this.handlerStep.bind(this);
    this.changeData = this.changeData.bind(this);

  }

  changeData(args){
    this.setState({
      [args.name]: args.value
    });
  }

  handlerStep(args) {

    let step = args.step;

    if(step === 'pagamento'){
      //se for pagamento mandamos o cliente para a tela de agradecimento
      step = arrayForms.length-1;
    }

    this.setState({
      formAtivo: step
    });
  }

  render(){
    arrayForms = [
      <FormAcesso
        changeStep={this.handlerStep}
        step={0}
        dados={this.state}
        changeData={this.changeData}
      />,
      <FormTreino
        changeStep={this.handlerStep}
        step={1}
        dados={this.state}
        changeData={this.changeData}
      />,
      <FormProblemas
        history={this.props.history}
        changeStep={this.handlerStep}
        step={2}
        dados={this.state}
        changeData={this.changeData}
      />
    ];
    return(
      <div>
        <br /><br />
        <div className="box-login-logo"><img src={LOGO} /></div>
        <form className="form-login" autoComplete="off">
          {arrayForms[this.state.formAtivo]}
        </form>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/classes/cadastro/Cadastro.js